/* YPB sandbox only: keep browser scrolling native and responsive. */
(function () {
  if (typeof ScrollSmoother !== 'undefined' && typeof ScrollSmoother.create === 'function') {
    ScrollSmoother.create = function () {
      return null;
    };
  }

  document.documentElement.style.scrollBehavior = 'auto';
})();
